import { PokerTable } from "@/features/poker/PokerTable";

const LiveTable = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <PokerTable />
    </div>
  );
};

export default LiveTable;
